<template>
  <div class="helpTemplate">
    <div class="helpBox flex_center_between" @click="openHelp">
      <!-- <img src="~@/assets/images/help.png" alt="" /> -->
      <i class="iconfont icon-help"></i>
      <span>{{ $t("common.help") }}</span>
    </div>
    <div class="help-tip-wrap" v-if="visible">
      <div class="helpInnerBox" v-bind:class="{ mobilehelpInnerBox: !isPc }">
        <span class="closeIcon el-icon-close" @click="visible = false"></span>
        <div class="tip-box" v-if="$i18n.locale == 'zh'">
          <h2>若您未能接受到手机验证码，建议您：</h2>
          <p>
            1.请检查手机是否有安全应用拦截及过滤短信，暂时关闭拦截功能，然后再次尝试获取验证码。<br />
            2.短信网关拥堵或出现异常时会导致已发送的短信出现延时或丢失的情况，建议过段时间再尝试获取。<br />
            3.请确认手机内存是否已满，若已满，请先清除旧短信或不常用的应用。<br />
            4.可能是手机本身的原因，建议将手机卡换到其他手机上再次进行尝试。<br />
            5.更换其他手机号尝试
          </p>
          <h2>若您未能接受到邮件，建议您：</h2>
          <p>
            1.查看被拦截邮件或垃圾邮箱 <br />
            2.更换其他邮箱尝试
          </p>
          <h2>若仍无法完成操作，请联系我们</h2>
          <p>contact@51xueshuo.com</p>
          <div class="close-btn" @click="closeDialog">我知道了</div>
        </div>
        <div class="tip-box" v-if="$i18n.locale == 'en'">
          <h2 class="en-tip">
            If your mobile phone failed to receive the verification code, we
            suggest you:
          </h2>
          <p class="en-tip">
            1. Check whether your phone has security application to intercept
            and filter SMS. If so, please turn off the interception function
            temporarily, and then try to obtain the verification code again.
            <br />
            2.Try to obtain it after a period of time. That is because the sent
            message will be delayed or lost when the SMS gateway is congested or
            abnormal. <br />
            3. Confirm whether the mobile phone memory is full. If it is full,
            please clear old SMS or infrequently used applications first. <br />
            4. Change the SIM card to another mobile phone and try again. <br />
            5. Try another mobile phone number.
          </p>
          <h2 class="en-tip">
            If you fail to receive the email, we suggest you:
          </h2>
          <p class="en-tip">
            1. View blocked mail or spam mailbox <br />
            2. Try another e-mail address
          </p>
          <h2 class="en-tip">
            If you still cannot complete the procedures , please contact us:
          </h2>
          <p>contact@51xueshuo.com</p>
          <div class="close-btn" @click="closeDialog">I know</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/utils";
export default {
  name: "help-tip",
  data() {
    return {
      visible: false,
      isPc: true,
    };
  },
  created() {
    this.isPc = utils.isPc();
    console.log(this.isPc);
  },
  methods: {
    openHelp() {
      this.visible = true;
    },
    openDialog() {
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss">
.helpTemplate {
   color: $mainColor;
  .helpBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
    i.iconfont {
      color: $mainColor;
     font-size: 14px;
      margin-right: 2px;
    }
  }
  .help-tip-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 20;
    .helpInnerBox {
      width: 510px;
      margin: 0 auto 50px;
      background: #fff;
      border-radius: 2px;
      box-sizing: border-box;
      margin-top: 15vh;
      position: relative;
      color: $navColor;
      &.mobilehelpInnerBox {
        width: 92%;
      }
    }
    .closeIcon {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 0;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      font-size: 16px;
    }
    .tip-box {
      padding: 34px 30px;
    }
    h2 {
      font-size: 14px;
      line-height: 26px;
      &.en-tip {
        word-break: keep-all;
      }
    }
    p {
      font-size: 14px;
      line-height: 26px;
      margin-bottom: 38px;
      text-align: justify;
      &.en-tip {
        word-break: keep-all;
      }
    }
    .close-btn {
      margin: 0 auto;
      width: 200px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 15px;
      background: $mainColor;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
    }
    @media screen and (max-width: 720px) {
      .el-dialog {
        width: 92% !important;
      }
    }
  }
}
</style>